import { SchoolMemberFragment } from 'shared/graphql';
import { ExplorerUserCard } from 'features/explorer/components';

interface Props {
  data: SchoolMemberFragment;
}

export function JobSeekersListItem({ data: item }: Props) {
  return <ExplorerUserCard data={item} withMessage withViewProfile />;
}
